'use client'
import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

export default function Home() {
  const [galleryPhotos, setGalleryPhotos] = useState([]);
  const [loadingGallery, setLoadingGallery] = useState(true);
  const [mounted, setMounted] = useState(false);

  const calculateTimeLeft = () => {
    const targetDate = new Date("2026-05-03T09:00:00+05:30"); // IST
    const now = new Date();
    const difference = targetDate - now;

    if (difference <= 0) {
      return {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    return {
      days: String(days).padStart(2, "0"),
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
      seconds: String(seconds).padStart(2, "0"),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Fetch home page featured gallery photos
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        // First try to fetch featured home gallery
        const response = await fetch('/api/admin/home-gallery');
        const data = await response.json();

        if (data.success && data.gallery.length > 0) {
          // Use featured gallery if available
          const featuredPhotos = data.gallery.slice(0, 6);

          // If we have fewer than 6 featured photos, fill with public gallery photos
          if (featuredPhotos.length < 6) {
            const publicResponse = await fetch('/api/gallery/public');
            const publicData = await publicResponse.json();
            if (publicData.success) {
              const remainingCount = 6 - featuredPhotos.length;
              const publicPhotos = publicData.gallery
                .filter(photo => !featuredPhotos.some(fp => fp._id === photo._id))
                .slice(0, remainingCount);
              setGalleryPhotos([...featuredPhotos, ...publicPhotos]);
            } else {
              setGalleryPhotos(featuredPhotos);
            }
          } else {
            setGalleryPhotos(featuredPhotos);
          }
        } else {
          // Fallback to public gallery if no featured gallery
          const publicResponse = await fetch('/api/gallery/public');
          const publicData = await publicResponse.json();
          if (publicData.success) {
            setGalleryPhotos(publicData.gallery.slice(0, 6));
          }
        }
      } catch (error) {
        console.error('Error fetching gallery:', error);
      } finally {
        setLoadingGallery(false);
      }
    };

    fetchGallery();
  }, []);

  return (
    <>
      <div className="home_banner">
        <img className="desktop" src="/home/desktop.jpg" alt="" />
        <img className="mobile" src="/home/mobile.jpg" alt="" />
        
      </div>

      <div className="counter_tim">
        <div className="container">
          <div className="counter_timer_img">
            <img src="/home/counter_event.jpg" alt="Counter Event" />

            <div className="counter_date">
              {mounted && (
                <>
                  <h2>{timeLeft.days} Days</h2>
                  <h3>
                    {timeLeft.hours}h :
                    {timeLeft.minutes}m :
                    {timeLeft.seconds}s
                  </h3>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <img className="mobile" src="/home/GHG-filler-1.jpg" alt="" />
      <img className="mobile" src="/home/GHG-filler-2.jpg" alt="" />
      <img className="mobile" src="/home/GHG-filler-3.jpg" alt="" />
      <img className="mobile" src="/home/GHG-filler-4.jpg" alt="" />

      {/* Gallery Preview Section */}
      <div className="home_gallery_section">
        <div className="container">
          <div className="gallery_header">
            <h2 className="gallery_title">Photo Gallery / ફોટો ગેલેરી</h2>

          </div>

          {loadingGallery ? (
            <div className="gallery_loading">
              <div className="spinner"></div>
              <p>Loading gallery...</p>
            </div>
          ) : galleryPhotos.length === 0 ? (
            <div className="gallery_empty">
              <p>No public photos available yet</p>
            </div>
          ) : (
            <div className="gallery_grid_home">
              {galleryPhotos.map((photo, index) => (
                <div key={photo._id || index} className="gallery_item" style={{ marginBottom: '1rem' }}>
                  <div className="gallery_image_wrapper">
                    <Image
                      src={photo.path}
                      alt={`Gallery photo ${index + 1}`}
                      width={400}
                      height={300}
                      quality={85}
                      loading="lazy"
                      className="gallery_image"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                  {photo.uploadedBy && (
                    <div className="gallery_uploader">
                      <span className="uploader_name">
                        {photo.uploadedBy.name} {photo.uploadedBy.surname}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <Link href="/gallery" className="view_more_btn">
          View More Photos →
        </Link>
      </div>

      <style jsx>{`
        .home_gallery_section {
          padding: 3rem 0;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        }

        .gallery_header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .gallery_title {
          font-size: 2rem;
          font-weight: 700;
          color: #2c3e50;
          margin: 0;
          text-align: center;
          flex: 1;
        }

        .view_more_btn {
          padding: 0.75rem 1.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          text-decoration: none;
          border-radius: 25px;
          font-weight: 600;
          text-align: center;
          display: inline-block;
          margin: 2rem auto;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }

        .view_more_btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
        }

        .gallery_loading {
          text-align: center;
          padding: 3rem;
          color: #666;
        }

        .spinner {
          border: 3px solid #f3f3f3;
          border-top: 3px solid #667eea;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
          margin: 0 auto 1rem;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .gallery_empty {
          text-align: center;
          padding: 3rem;
          color: #999;
          font-size: 1.1rem;
        }

        .gallery_grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 1.5rem;
          padding: 1rem 0;
        }

        .gallery_item {
          position: relative;
          border-radius: 12px;
          width: 30%;
          height: 200px;
          overflow: hidden;
          background: white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .gallery_item:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .gallery_image_wrapper {
          position: relative;
          width: 100%;
          overflow: hidden;
          background: #f0f0f0;
        }

        .gallery_image {
          position: absolute;
          top: 0;
          left: 0;
          transition: transform 0.3s ease;
        }

        .gallery_item:hover .gallery_image {
          transform: scale(1.05);
        }

        .gallery_uploader {
          padding: 0.75rem 1rem;
          background: rgba(255, 255, 255, 0.95);
          border-top: 1px solid #eee;
        }

        .uploader_name {
          font-size: 0.9rem;
          color: #555;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .gallery_header {
            flex-direction: column;
            text-align: center;
          }

          .gallery_title {
            font-size: 1.5rem;
          }

          .gallery_grid {
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 1rem;
          }

          .home_gallery_section {
            padding: 2rem 0;
          }
            .gallery_item{
            width: 100%;
            height: auto;
          }
        }

        @media (max-width: 480px) {
          .gallery_grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

    </>
  );
}
